import { atom } from 'recoil';
import BeaconFilterRange from '../models/BeaconFilterRange';

const stateFilterVariant = atom({
  key: 'filter.range',
  default: null as BeaconFilterRange | null,
});

export default stateFilterVariant;
